const dataFile = new FormData();

export const archiveRequestPayload = dataFile;

export const archiveDataResponse = {
  successMessage: 'success',
  errorMessage:
    'savePresign returned a null SaveContentResponse. Unable to archive.'
};
